import React, { useState, useCallback, useEffect } from 'react';

const SafetyAuthEditCheckedInput = ({ register, authIdx, authNm, trigger }) => {
  const [isChecked, setIsChecked] = useState(trigger);

  useEffect(() => {
    setIsChecked(trigger);
  }, [trigger]);

  const toggleChange = useCallback(() => {
    setIsChecked((isChecked) => {
      return !isChecked;
    });
  }, [isChecked]);

  return (
    <label>
      <input
        type="checkbox"
        name="manageTargetAuth"
        ref={register({ required: true })}
        value={authIdx}
        checked={isChecked}
        onChange={() => {
          toggleChange();
        }}
      />
      {authNm}
    </label>
  );
};

export default SafetyAuthEditCheckedInput;
